import styled, { StyledProps } from 'styled-components/macro';

export type PaginationStylesProps = StyledProps<{
  active: boolean;
}>;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 13px auto 0;
  max-width: 100%;
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PaginationItem = styled.div<PaginationStylesProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  overflow: hidden;
  margin-left: 4px;
  color: ${(props) => (props.active ? '#fff' : '#1D1E25')};
  font-size: 12px;
  cursor: pointer;
  &:first-child {
    margin-left: 0;
  }
  ${(props) =>
    props.active
      ? `
    background: #0076C0;
    box-shadow: inset 0px 0.1px 4px rgba(0, 0, 0, 0.15);
  `
      : ``}
`;

export const PaginationInfo = styled.div`
  width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #424242;

  & div > div > button {
    color: #000;
  }
`;
